/**
 * 大鹅 PC 分页组件（替代 jsPagination/lib）
 * DOM 类名与旧插件 type=2 保持一致，便于复用页面 SCSS
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var DEFAULT_LAYOUT = 'home, prev, pager, next, jumper, last';
export function parseDaetoolWebInfo(raw) {
    return {
        current_page: Number(raw.current_page) || 1,
        per_page: Number(raw.per_page) || 8,
        total: Number(raw.total) || 0,
        last_page: Number(raw.last_page) || 1,
    };
}
var DaetoolPagination = /** @class */ (function () {
    function DaetoolPagination(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.pageNum = 0;
        this.validate(options);
        var el = document.querySelector(options.element);
        if (!el) {
            throw new Error("[DaetoolPagination] element not found: ".concat(options.element));
        }
        this.root = el;
        this.options = {
            element: options.element,
            pageIndex: (_a = options.pageIndex) !== null && _a !== void 0 ? _a : 1,
            pageSize: options.pageSize,
            pageCount: (_b = options.pageCount) !== null && _b !== void 0 ? _b : 5,
            total: options.total,
            layout: (_c = options.layout) !== null && _c !== void 0 ? _c : DEFAULT_LAYOUT,
            type: (_d = options.type) !== null && _d !== void 0 ? _d : 2,
            singlePageHide: (_e = options.singlePageHide) !== null && _e !== void 0 ? _e : true,
            ellipsis: (_f = options.ellipsis) !== null && _f !== void 0 ? _f : true,
            disabled: (_g = options.disabled) !== null && _g !== void 0 ? _g : true,
            jumperInvalidText: (_h = options.jumperInvalidText) !== null && _h !== void 0 ? _h : '该页码无效',
            currentChange: options.currentChange,
        };
        this.render();
    }
    DaetoolPagination.prototype.validate = function (options) {
        var _a;
        if (!options.element) {
            throw new Error('[DaetoolPagination] element is required');
        }
        var pageCount = (_a = options.pageCount) !== null && _a !== void 0 ? _a : 5;
        if (pageCount % 2 === 0) {
            throw new Error('[DaetoolPagination] pageCount must be an odd number');
        }
        if (pageCount < 5) {
            throw new Error('[DaetoolPagination] pageCount must be >= 5');
        }
    };
    Object.defineProperty(DaetoolPagination.prototype, "layouts", {
        get: function () {
            return this.options.layout
                .split(',')
                .map(function (s) { return s.trim(); })
                .filter(function (key) {
                return ['home', 'prev', 'pager', 'next', 'last', 'jumper'].includes(key);
            });
        },
        enumerable: false,
        configurable: true
    });
    DaetoolPagination.prototype.render = function () {
        var _this = this;
        this.pageNum = Math.max(1, Math.ceil(this.options.total / this.options.pageSize));
        if (this.pageNum <= 1 && this.options.singlePageHide) {
            this.root.innerHTML = '';
            return;
        }
        if (this.options.pageIndex > this.pageNum) {
            this.options.pageIndex = this.pageNum;
        }
        if (this.options.pageIndex < 1) {
            this.options.pageIndex = 1;
        }
        var container = this.createEl('div', '_page_container');
        this.layouts.forEach(function (key) {
            var block = _this.renderBlock(key);
            if (block) {
                container.appendChild(block);
            }
        });
        this.root.innerHTML = '';
        this.root.appendChild(container);
    };
    DaetoolPagination.prototype.renderBlock = function (key) {
        switch (key) {
            case 'home':
                return this.renderHome();
            case 'prev':
                return this.renderPrev();
            case 'pager':
                return this.renderPager();
            case 'next':
                return this.renderNext();
            case 'last':
                return this.renderLast();
            case 'jumper':
                return this.renderJumper();
            default:
                return null;
        }
    };
    DaetoolPagination.prototype.renderHome = function () {
        var _this = this;
        var disabled = this.options.pageIndex <= 1;
        var el = this.createEl('div', __spreadArray(__spreadArray([
            '_home',
            "_home_".concat(this.options.type)
        ], (disabled ? ['_disabled_c'] : []), true), (disabled && this.options.disabled ? ['_disabled'] : []), true));
        el.textContent = '首页';
        if (!disabled) {
            el.addEventListener('click', function () { return _this.changePage(1); });
        }
        return el;
    };
    DaetoolPagination.prototype.renderPrev = function () {
        var _this = this;
        var disabled = this.options.pageIndex <= 1;
        var el = this.createEl('div', __spreadArray(__spreadArray([
            '_prev',
            "_prev_".concat(this.options.type)
        ], (disabled ? ['_disabled_c'] : []), true), (disabled && this.options.disabled ? ['_disabled'] : []), true));
        el.setAttribute('aria-label', '上一页');
        el.appendChild(this.createArrowIcon('left'));
        if (!disabled) {
            el.addEventListener('click', function () { return _this.changePage(_this.options.pageIndex - 1); });
        }
        return el;
    };
    DaetoolPagination.prototype.renderNext = function () {
        var _this = this;
        var disabled = this.options.pageIndex >= this.pageNum;
        var el = this.createEl('div', __spreadArray(__spreadArray([
            '_next',
            "_next_".concat(this.options.type)
        ], (disabled ? ['_disabled_c'] : []), true), (disabled && this.options.disabled ? ['_disabled'] : []), true));
        el.setAttribute('aria-label', '下一页');
        el.appendChild(this.createArrowIcon('right'));
        if (!disabled) {
            el.addEventListener('click', function () { return _this.changePage(_this.options.pageIndex + 1); });
        }
        return el;
    };
    /** 左右翻页箭头（与 Figma pagination-icon 一致） */
    DaetoolPagination.prototype.createArrowIcon = function (direction) {
        var wrap = this.createEl('span', '_arrow_icon');
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', '_arrow_svg');
        svg.setAttribute('width', '14');
        svg.setAttribute('height', '14');
        svg.setAttribute('viewBox', '0 0 6 11');
        svg.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        if (direction === 'left') {
            path.setAttribute('d', 'M4.93555 0C5.04487 0.0000330134 5.14073 0.0411216 5.22266 0.123047C5.30448 0.204961 5.3457 0.30087 5.3457 0.410156C5.34564 0.51942 5.30455 0.615374 5.22266 0.697266L0.957031 5.07227L5.22266 9.44727C5.30441 9.52916 5.3457 9.62514 5.3457 9.73438C5.34558 9.84341 5.30429 9.93874 5.22266 10.0205C5.14073 10.1024 5.04487 10.1435 4.93555 10.1436C4.82617 10.1436 4.7304 10.1071 4.64844 10.0342L0.123047 5.37207C0.0411758 5.28111 0 5.17843 0 5.06445C0.000104468 4.9506 0.0411931 4.85236 0.123047 4.77051L4.64844 0.109375C4.7304 0.0364583 4.82617 0 4.93555 0Z');
        }
        else {
            path.setAttribute('d', 'M0.410156 0C0.519428 0.0000549764 0.615369 0.0365134 0.697266 0.109375L5.22266 4.77148C5.30448 4.85337 5.34566 4.95371 5.3457 5.07227C5.3457 5.19082 5.3044 5.29115 5.22266 5.37305L0.697266 10.0352C0.615369 10.108 0.519428 10.1445 0.410156 10.1445C0.300781 10.1445 0.205005 10.1034 0.123047 10.0215C0.0412932 9.93967 0.000114501 9.84447 0 9.73535C0 9.62602 0.0411591 9.53018 0.123047 9.44824L4.38867 5.07324L0.123047 0.698242C0.0411486 0.616344 0.0000600011 0.520408 0 0.411133C0 0.301758 0.0410885 0.200667 0.123047 0.109375C0.204979 0.0365277 0.300833 0 0.410156 0Z');
        }
        path.setAttribute('fill', 'currentColor');
        svg.appendChild(path);
        wrap.appendChild(svg);
        return wrap;
    };
    DaetoolPagination.prototype.renderLast = function () {
        var _this = this;
        var disabled = this.options.pageIndex >= this.pageNum;
        var el = this.createEl('div', __spreadArray(__spreadArray([
            '_last',
            "_last_".concat(this.options.type)
        ], (disabled ? ['_disabled_c'] : []), true), (disabled && this.options.disabled ? ['_disabled'] : []), true));
        el.textContent = '尾页';
        if (!disabled) {
            el.addEventListener('click', function () { return _this.changePage(_this.pageNum); });
        }
        return el;
    };
    DaetoolPagination.prototype.renderPager = function () {
        var _this = this;
        var ul = this.createEl('ul', ['_pages', "_pages_".concat(this.options.type)]);
        var between = this.getBetween();
        var pages = this.range(between.min, between.max);
        if (this.options.ellipsis) {
            if (pages[0] && Number(pages[0]) > 1) {
                pages = __spreadArray([1, '...'], pages.slice(1), true);
            }
            if (pages[pages.length - 1] && Number(pages[pages.length - 1]) < this.pageNum) {
                pages = __spreadArray(__spreadArray([], pages.slice(0, -1), true), ['...', this.pageNum], false);
            }
        }
        pages.forEach(function (item, index) {
            if (item === '...') {
                var li_1 = _this.createEl('li', ["_pages_li_".concat(_this.options.type)]);
                li_1.textContent = '...';
                if (index <= 1) {
                    li_1.classList.add('_pager_prev');
                    li_1.addEventListener('click', function () {
                        var target = Math.max(1, _this.options.pageIndex - _this.options.pageCount + 2);
                        _this.changePage(target);
                    });
                }
                else {
                    li_1.classList.add('_pager_next');
                    li_1.addEventListener('click', function () {
                        var target = Math.min(_this.pageNum, _this.options.pageIndex + _this.options.pageCount - 2);
                        _this.changePage(target);
                    });
                }
                ul.appendChild(li_1);
                return;
            }
            var page = item;
            var active = page === _this.options.pageIndex;
            var li = _this.createEl('li', __spreadArray(__spreadArray([
                "_pages_li_".concat(_this.options.type)
            ], (active ? ["_active_".concat(_this.options.type)] : []), true), (active && _this.options.disabled ? ['_disabled'] : []), true));
            li.textContent = String(page);
            if (!active) {
                li.addEventListener('click', function () { return _this.changePage(page); });
            }
            ul.appendChild(li);
        });
        return ul;
    };
    DaetoolPagination.prototype.renderJumper = function () {
        var _this = this;
        var wrap = this.createEl('div', '_jumper');
        var labelBefore = this.createEl('span', '_jumper_label');
        labelBefore.textContent = '跳至';
        wrap.appendChild(labelBefore);
        var field = this.createEl('div', '_jumper_field');
        var input = this.createEl('input', '_jumper_input');
        input.type = 'number';
        input.min = '1';
        input.max = String(this.pageNum);
        input.value = String(this.options.pageIndex);
        var errorTip = this.createEl('span', '_jumper_error');
        errorTip.textContent = this.options.jumperInvalidText;
        errorTip.setAttribute('role', 'alert');
        errorTip.hidden = true;
        var showError = function () {
            errorTip.hidden = false;
            field.classList.add('_jumper_field--error');
        };
        var hideError = function () {
            errorTip.hidden = true;
            field.classList.remove('_jumper_field--error');
        };
        var tryJump = function () {
            var raw = input.value.trim();
            if (!raw) {
                showError();
                return;
            }
            var value = Number(raw);
            if (!Number.isInteger(value) || value < 1 || value > _this.pageNum) {
                showError();
                input.value = String(_this.options.pageIndex);
                return;
            }
            hideError();
            if (value !== _this.options.pageIndex) {
                _this.changePage(value);
            }
        };
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                tryJump();
            }
        });
        input.addEventListener('blur', tryJump);
        input.addEventListener('input', hideError);
        field.appendChild(input);
        field.appendChild(errorTip);
        wrap.appendChild(field);
        var labelAfter = this.createEl('span', '_jumper_label');
        labelAfter.textContent = '页';
        wrap.appendChild(labelAfter);
        return wrap;
    };
    DaetoolPagination.prototype.changePage = function (index) {
        if (index === this.options.pageIndex) {
            return;
        }
        this.options.pageIndex = index;
        this.options.currentChange(index);
    };
    DaetoolPagination.prototype.getBetween = function () {
        var min = this.options.pageIndex - Math.floor(this.options.pageCount / 2);
        if (min > this.pageNum - this.options.pageCount) {
            min = this.pageNum - this.options.pageCount + 1;
        }
        if (min <= 1) {
            min = 1;
        }
        var max = this.options.pageIndex + Math.floor(this.options.pageCount / 2);
        if (max < this.options.pageCount) {
            max = this.options.pageCount;
        }
        if (max > this.pageNum) {
            max = this.pageNum;
        }
        return { min: min, max: max };
    };
    DaetoolPagination.prototype.range = function (start, end) {
        var arr = [];
        for (var i = start; i <= end; i += 1) {
            arr.push(i);
        }
        return arr;
    };
    DaetoolPagination.prototype.createEl = function (tag, classList) {
        var el = document.createElement(tag);
        if (!classList) {
            return el;
        }
        var list = Array.isArray(classList) ? classList : [classList];
        list.forEach(function (cls) { return el.classList.add(cls); });
        return el;
    };
    return DaetoolPagination;
}());
export default DaetoolPagination;
